export default __webpack_public_path__ + "static/media/kp.9fd3021e.svg";